// Функциональный вариант оператора switch
export const what = <TKey extends string, TValue>(
  key: TKey | undefined,
  cases: Partial<Record<TKey, TValue>>,
  defaultValue: TValue,
): TValue => (key && cases[key]) ?? defaultValue;
